// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__14p5L","inner":"Footer_inner__3yMtU","nextIcon":"Footer_nextIcon__1pmAl","innerLeft":"Footer_innerLeft__2bWtk"};